import Vue from 'vue';

Vue.component('promotion-index', () =>
    import(/* webpackChunkName: 'promotion' */ './promotion-index.vue'),
);

Vue.component('promotion-detail', () =>
    import(/* webpackChunkName: 'promotion' */ './promotion-detail.vue'),
);

Vue.component('station_list', () =>
    import(/* webpackChunkName: 'promotion' */ './station_list.vue'),
);
